import {
    apiRequest,
    HDdetail,
    HDCreateSP,
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HDdetail, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", HDCreateSP, {
            body: query
        }, true)
    }
}

export default UpdateRepository